import domReady from '@wordpress/dom-ready';

domReady(() => {
  const backBtn = document.querySelector('#back-to-top');

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      document.getElementById('main-content').focus();
      window.scrollTo(0, 0);
    });
  }
});
